import { Component, OnInit } from '@angular/core';
import { BlipChatControlSingleton } from '../utils';
import { HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TransferModalComponent } from '../transfer-modal/transfer-modal.component';
import { Route } from '@angular/compiler/src/core';
import { ActivatedRoute } from '@angular/router';
import { CUSTOM_WALLETS_DATASET } from '../custom-wallet-builder/data';
import { HttpService } from '@toro/common/shared/services/http/http.service';

@Component({
    selector: "app-custom-plan",
    templateUrl: "./custom-plan.component.html",
    styleUrls: ["./custom-plan.component.scss"]
})
export class CustomPlanComponent {
    public isMobile = false;
    public blipController = BlipChatControlSingleton;
    public plan = {
        slug: "",
        data: null
    };
    public wallet;

    constructor(private dialog: MatDialog, 
                private route: ActivatedRoute,
                private HttpService: HttpService) {
        this.plan.slug = this.route.snapshot.paramMap.get("planSlug");
    }

    public openTransferModal() {
        this.dialog.open(TransferModalComponent, {
            minWidth: "100vw",
            height: "100vh"
        });
    }

    fetchPlanData() {
        this.plan.data = CUSTOM_WALLETS_DATASET.filter(
            p => p.name == this.plan.slug
        )[0];
        
        this.HttpService.get(this.plan.data.resourceUrls.data).subscribe(
            wallet => this.wallet = wallet
        );

        return this;
    }

    ngOnInit() {
        this.blipController.hideChat();
        this.fetchPlanData();
    }
}
